import { useState } from "react";
import { IPartnerEngagementDetailsChartProps } from "../../interfaces/PartnerView.interfaces";
import { CustomCardWithMetrics } from "../../SharedComponents/CustomCardWithMetrics";
import { ChartOption } from "../../SharedComponents/Interfaces/CustomCardWithMetrics.interfaces";
import { CUSTOMER_VIEW_STYLES } from "../CustomerView/CustomerView.styles";

export default function PartnerEngagementChart(props: IPartnerEngagementDetailsChartProps) {
  // Properties
  const [metricFilters, setMetricFilters] = useState<{ [key: string]: any }>({});

  // Events
  const handleResetFilters = () => {
    setMetricFilters({});
    props.onSelectedChartFilter({
      filterKey: "",
      value: ""
    });
  };
  /**
   * onClick action for each datapoint in the chart
   */
  const handleDataPointClick = ({ field, title, value }: ChartOption) => {
    props.onSelectedChartFilter({
      filterKey: field,
      value: value
    });
    setMetricFilters((prev) => ({ ...prev, [title]: value }));
  };

  return (
    <>
      <div className={CUSTOMER_VIEW_STYLES.COMMON_STYLES.CLASS_NAMES.customCardContainer}>
        <CustomCardWithMetrics
          enableUrlParams
          loading={props.loading}
          metricFilters={metricFilters}
          onDataPointClick={handleDataPointClick}
          onResetFilters={handleResetFilters}
          options={props.options}
        />
      </div>
    </>
  );
}
